import React from 'react';
import Transition from '../components/Transition';
import Pageheader from '../utils/headerHelment';

const TransitionView = () => {
    return (
        <>
            <Pageheader title="LENS - Transition" />
            <Transition />
        </>
    );
};

export default TransitionView;
